export default "/8522fe2631ecefb1e3967be9883671f05392a386/decc719ac0c1523cc2040d71b927dcbc.svg";